import React, { useState, useEffect } from 'react';
import {
    Container, Paper, Typography, Box, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Chip, Collapse, IconButton
} from '@mui/material';
import { History as HistoryIcon, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'; // Remove ExpandCircleDown if not available
import { toast } from 'react-toastify';
import { API_BASE_URL, formatDate } from '../config';
import { useAuth } from '../contexts/AuthContext';

const LogRow = ({ log }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' }, cursor: 'pointer' }} onClick={() => setOpen(!open)} hover>
                <TableCell>
                    <IconButton aria-label="expand row" size="small">
                        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {log.username || 'System'}
                </TableCell>
                <TableCell>
                    <Chip
                        label={log.action}
                        color={['DELETE', 'LOGIN'].includes(log.action) ? 'warning' : 'primary'}
                        size="small"
                        variant="outlined"
                    />
                </TableCell>
                <TableCell>{log.entity} #{log.entity_id}</TableCell>
                <TableCell>{new Date(log.created_at).toLocaleString()}</TableCell>
                <TableCell>{log.ip_address}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="h6" gutterBottom component="div" sx={{ fontSize: '0.9rem' }}>
                                Change Details
                            </Typography>
                            <Paper sx={{ p: 2, bgcolor: '#f8f9fa' }} variant="outlined">
                                <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: '0.85rem' }}>
                                    {JSON.stringify(log.details, null, 2)}
                                </pre>
                            </Paper>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

const AuditLogs = () => {
    const { token } = useAuth();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchLogs();
    }, []);

    const fetchLogs = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth/audit-logs`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            if (data.success) {
                setLogs(data.data);
            }
        } catch (error) {
            toast.error('Failed to load audit logs');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="xl" sx={{ mt: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 2 }}>
                <HistoryIcon fontSize="large" color="primary" />
                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                    Audit Trail
                </Typography>
            </Box>

            <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: 4 }}>
                <TableContainer sx={{ maxHeight: '80vh' }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell width={50} />
                                <TableCell>User</TableCell>
                                <TableCell>Action</TableCell>
                                <TableCell>Entity</TableCell>
                                <TableCell>Timestamp</TableCell>
                                <TableCell>IP Address</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map((log) => (
                                <LogRow key={log.id} log={log} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Container>
    );
};

export default AuditLogs;
